import React from 'react';
import { Box, Button, Link, useMediaQuery } from '@mui/material';
import logo from "../../assets/logo/logo.png"
import { useNavigate } from 'react-router-dom';
const PreFooter: React.FC = () => {

  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width:768px)");
  
  const handleClickLogin = () => navigate("/minha-innova/admin");
  
  return (
    <Box
      sx={{
        backgroundColor: '#f8f8f8',
        padding: '20px',
        display: 'flex',
        width: "100%",
        flexFlow: isMobile ? "column" : "row nowrap",
        alignItems: 'center',
        justifyContent: "center",
        gap: isMobile ? 0 : "2em",
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <img src={logo} alt="Logo" width={ isMobile ? "100px" : "250px"} />
      </Box>
      <Box sx={{ 
        display: 'flex', 
        flexFlow: "row wrap",
        justifyContent: "space-evenly",
        gap: 2, 
        marginTop: 2 
      }}>
        {/* <Link href="#" className='a'>
          Trabalhe conosco
        </Link> */}
        <Link href="#" className='a' color='#004387'>
          Sobre
        </Link>
        <Link href="/credenciado" className='a' color='#004387'>
          Seja nosso Parceiro
        </Link>
        <Link href="#" className='a' color='#004387'>
          Fale conosco
        </Link>
        <Link href="#" className='a' color='#004387'>
          Ouvidoria
        </Link>
        <Link href="/politicas-de-privacidade-e-lgpd" className='a' color='#004387'>
          Política de Privacidade
        </Link>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, marginTop: 2, flexDirection: "column" }}>
        <Button variant="contained" color="warning" onClick={handleClickLogin}>
          Login
        </Button>
        {/* <Button variant="outlined" color="warning">
          Comercial
        </Button> */}
      </Box>
    </Box>
  );
};

export default PreFooter;
